import axios from 'axios';
import { Toast } from 'vant';
import { getDeviceInfo, getDrawInfo } from '@/libs/tool';
import store from '@/store';

class HttpRequest {
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
        this.queue = {};
    }

    getInsideConfig() {
        const { deviceId, deviceType, terminalType } = getDeviceInfo();
        const { drawToken } = getDrawInfo();
        const config = {
            baseURL: this.baseUrl,
            timeout: 30000,
            headers: {
                'X-Device-Id': deviceId,
                'X-Device-Type': deviceType,
                'X-Terminal-Type': terminalType,
                'X-Draw-Reward-Token': drawToken,
                'account': store.state.tradeAccount || '',
                'encryptAccount': store.state.encryptTradeAccount || '',
                'secaccount': store.state.secaccount || ''
            }
        };
        return config;
    }

    destroy(url) {
        delete this.queue[url];
        if (!Object.keys(this.queue).length) {
            // Spin.hide()
        }
    }

    interceptors(instance, url) {
        // 请求拦截
        instance.interceptors.request.use(
            config => {
                // 添加全局的loading...
                if (!Object.keys(this.queue).length) {
                    // Spin.show() // 不建议开启，因为界面不友好
                }
                this.queue[url] = true;
                return config;
            },
            error => {
                return Promise.reject(error);
            }
        );
        // 响应拦截
        instance.interceptors.response.use(
            res => {
                this.destroy(url);
                const { data, status } = res;
                // if (data.code && !data.success && data.code !== '200') {
                //     Toast(data.message || `错误.code:${data.code}`);
                // }
                return { data, status };
            },
            error => {
                this.destroy(url);
                try {
                    Toast('您的网络较差，请稍后再试！');
                } catch (err) {
                    console.log(err);
                }
                return Promise.reject(error);
            }
        );
    }

    request(options) {
        const instance = axios.create();
        // eslint-disable-next-line no-param-reassign
        options = Object.assign(this.getInsideConfig(), options, { withCredentials: true });
        if (options.method === 'get' || options.method === undefined) {
            if (options.params) {
                options.params._t = new Date().getTime();
            } else {
                options.params = {
                    _t: new Date().getTime()
                };
            }
        }
        this.interceptors(instance, options.url);
        return instance(options);
    }
}
export default HttpRequest;
